export function buildAuthorshipSelects(indent = '      '): string[] {
  return [
    `${indent}createdByUser: { id: createdByUser.id, name: createdByUser.name, email: createdByUser.email }`,
    `${indent}updatedByUser: { id: updatedByUser.id, name: updatedByUser.name, email: updatedByUser.email }`
  ]
}
